// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import FieldData from './FieldData';
// import { Box, Button, Grid, IconButton, InputLabel, MenuItem, Pagination, Select } from '@mui/material';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import SearchImg from '../../assets/search.svg';
// import { useNavigate } from 'react-router';
// import ClearIcon from '@mui/icons-material/Close';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   setAllStaffs,
//   setFilters,
//   setCurrentPage,
//   setPagination,
//   resetFilters,
//   setLoading // Add this import
// } from 'src/redux/slices/staffSlice';
// import BigFilter from 'src/components/inputs/BigFilter';

// const filterGenderWise = [
//   { value: 'Female', label: 'Female' },
//   { value: 'Male', label: 'Male' },
//   { value: 'Both', label: 'Both' },
// ];

// const AllStaffs = () => {
//   const { fetchAllStaffs, activeBranchId } = useMain();
//   const dispatch = useDispatch();
//   const navigate = useNavigate()
//   const { displayedStaffs, filters, pagination, loading } = useSelector((state) => state.staffs);


//     const getData = async () => {
//     try {
//       dispatch(setLoading(true));
//       const res = await fetchAllStaffs(activeBranchId);
//       if (res.statusCode === 200) {
//         dispatch(setAllStaffs(res?.data || []));
//       }
//     } catch (error) {
//       console.error('Error fetching staff:', error);
//     } finally {
//       dispatch(setLoading(false));
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       getData();
//     }
//     return () => {
//       dispatch(setAllStaffs([]));
//       dispatch(resetFilters());
//     };
//   }, [activeBranchId]);


//    const handleLimitChange = (e) => {
//     dispatch(
//       setPagination({
//         itemsPerPage: e.target.value,
//         currentPage: 1,
//       }),
//     );
//   };


//   const handlePageChange = (e, value) => {
//     dispatch(setCurrentPage(value));
//   };

//     const handleSearchChange = (e) => {
//     dispatch(setFilters({ search: e.target.value }));
//   };

//   // Handle filter changes from BigFilter
//   const handleFilterChange = (selectedValues) => {
//     const genders = selectedValues.filter(val =>
//       filterGenderWise.some(opt => opt.value === val));
//     dispatch(setFilters({ gender: genders }));
//   };

//   // Combine all selected filters for BigFilter value prop
//   const selectedFilters = [...filters.gender];


//   return (
//     <PageContainer title="Manage Active Staffs" description="This contains all data">
//       <DashboardCard2 title="Manage Active Staffs">
//         {/* Main container with proper alignment */}
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             marginBottom: '1.7rem',
//             flexWrap: 'wrap',
//             gap: '1rem',
//           }}
//         >
//           {/* Left side - Page limit */}
//           <div style={{ display: 'flex', flexDirection: 'column', minWidth: '83px' }}>
//             <InputLabel>Show per page</InputLabel>
//             <Select
//               style={{
//                 borderRadius: '7px',
//                 border: '0.5px solid #6174DD',
//                 padding: '4px 12px',
//                 background: '#FFF',
//                 height: '40px',
//                 minWidth: '83px',
//               }}
//               value={pagination.itemsPerPage}
//               onChange={handleLimitChange}
//             >
//               <MenuItem value={10}>10</MenuItem>
//               <MenuItem value={20}>20</MenuItem>
//               <MenuItem value={50}>50</MenuItem>
//             </Select>
//           </div>

//           {/* Right side - Search, Filter and Work Analysis button */}
//           <div style={{ 
//             display: 'flex', 
//             alignItems: 'flex-end', 
//             gap: '1rem',
//             flexWrap: 'wrap',
//             justifyContent: 'flex-end',
//             flex: 1
//           }}>

//             {/* Filter */}
//             <div style={{ width:'150px', marginBottom: '0rem' ,marginRight:'-80px'}}>
//               <BigFilter
//                 options={[
//                   { title: 'Gender', items: filterGenderWise },
//                 ]}
//                 value={selectedFilters}
//                 onChange={handleFilterChange}
//                 placeholder="Filters"
//               />
//             </div>

//             {/* Search input */}
//             <div style={{ display: 'flex', flexDirection: 'column', minWidth: '100px' ,    marginLeft:'80px'}}>
//               <InputLabel>Search</InputLabel>
//               <div 
//                 className="search-input" 
//                 style={{ 
//                   display: 'flex', 
//                   alignItems: 'center',
//                   border: '0.5px solid #6174DD',
//                   borderRadius: '7px',
//                   padding: '4px 12px',
//                   background: '#FFF',
//                   height: '40px',
//                 }}
//               >
//                 <img src={SearchImg} alt="" style={{ marginRight: '8px' }} />
//                 <input
//                   style={{ 
//                     flex: 1, 
//                     border: 'none', 
//                     outline: 'none',
//                     background: 'transparent'
//                   }}
//                   type="text"
//                   placeholder="Search staff..."
//                   value={filters.search}
//                   onChange={handleSearchChange}
//                 />
//                 {filters.search && (
//                   <IconButton
//                     onClick={() => dispatch(setFilters({ search: '' }))}
//                     style={{ padding: 1 }}
//                   >
//                     <ClearIcon
//                       style={{
//                         color: '#000',
//                         fontSize: '1.1rem',
//                       }}
//                     />
//                   </IconButton>
//                 )}
//               </div>
//             </div>

//             {/* Work Analysis button */}
//             <div style={{ marginBottom: '0rem' }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 sx={{
//                   height: '40px',
//                   background: '#6174dd',
//                   '&:hover': { background: '#5d87ff' },
//                   minWidth: '140px'
//                 }}
//                 onClick={() => navigate('/WorkAnalysis')}
//               >
//                 Work Analysis
//               </Button>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <ShowLoader />
//         ) : displayedStaffs.length > 0 ? (
//           <>
//             <Box>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} lg={12}>
//                   <FieldData data={displayedStaffs} getData={getData} />
//                 </Grid>
//               </Grid>
//             </Box>
//           </>
//         ) : (
//           'No data found'
//         )}

//         {pagination.totalItems > 0 && (
//           <Box display={'flex'} justifyContent={'flex-end'} mt={3}>
//             <Pagination
//               count={pagination.totalPages}
//               page={pagination.currentPage}
//               color="primary"
//               onChange={handlePageChange}
//             />
//           </Box>
//         )}
//       </DashboardCard2>
//     </PageContainer>
//   );
// };

// export default AllStaffs;

import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import FieldData from './FieldData';
import { Box, Button, Grid, IconButton, InputLabel, MenuItem, Pagination, Select, Dialog,
  InputAdornment,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField, } from '@mui/material';
import TextInputs from 'src/components/inputs/TextInputs';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import SearchImg from '../../assets/search.svg';
import { useNavigate } from 'react-router';
import ClearIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAllStaffs,
  setFilters,
  setCurrentPage,
  setPagination,
  resetFilters,
  setLoading // Add this import
} from 'src/redux/slices/staffSlice';
import BigFilter from 'src/components/inputs/BigFilter';

const filterGenderWise = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
  { value: 'Both', label: 'Both' },
];

const AllStaffs = () => {
  const { fetchAllStaffs, activeBranchId, branchData, OwnerVarification, ownerData, setShowMessage , getOwnerIdByBranchId } = useMain();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { displayedStaffs, filters, pagination, loading } = useSelector((state) => state.staffs);
  const isMasked = branchData?.isMasked || false;
  
  /* MASK AUTH STATE */
  const [authOpen, setAuthOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [isAuthorised, setIsAuthorised] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
const [ownerId, setOwnerId] = useState(null);
  /* CHECK STORED ACCESS */
 /* CHECK STORED ACCESS */
useEffect(() => {
  if (!isMasked) {
    setIsAuthorised(true);
    return;
  }

  const ts = localStorage.getItem('reportAccessTimestamp');
  if (ts && Date.now() - ts < 10 * 60 * 1000) {
    setIsAuthorised(true);
  }
  // dialog opens only after ownerId loads — handled below
}, [isMasked]);

useEffect(() => {
  if (!isMasked || isAuthorised) return;
  if (ownerId) {
    setAuthOpen(true); // only open once ownerId is ready
  }
}, [ownerId, isMasked, isAuthorised]);
/* FETCH OWNER ID ON MOUNT/TAB OPEN */
useEffect(() => {
  const fetchOwnerIdOnLoad = async () => {
    const branchId = activeBranchId || branchData?._id || localStorage.getItem('branchId');
    if (branchId && typeof getOwnerIdByBranchId === 'function') {
      const ownerRes = await getOwnerIdByBranchId(branchId);
      const extractedId = ownerRes?.data?.ownerId || ownerRes?.ownerId || ownerRes?.data?._id;
      const finalId = (typeof extractedId === 'object' && extractedId?._id) ? extractedId._id : extractedId;
      if (typeof finalId === 'string') {
        setOwnerId(finalId);
      }
    }
  };
  fetchOwnerIdOnLoad();
}, [activeBranchId, branchData?._id, getOwnerIdByBranchId]);

  const getData = async () => {
    try {
      dispatch(setLoading(true));
      const res = await fetchAllStaffs(activeBranchId);
      if (res.statusCode === 200) {
        dispatch(setAllStaffs(res?.data || []));
      }
    } catch (error) {
      console.error('Error fetching staff:', error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    if (activeBranchId && isAuthorised) {
      getData();
    }
    return () => {
      dispatch(setAllStaffs([]));
      dispatch(resetFilters());
    };
  }, [activeBranchId, isAuthorised]);


  const handleLimitChange = (e) => {
    dispatch(
      setPagination({
        itemsPerPage: e.target.value,
        currentPage: 1,
      }),
    );
  };


  const handlePageChange = (e, value) => {
    dispatch(setCurrentPage(value));
  };

  // Remove only leading spaces while typing (spaces between words still work)
  const handleSearchChange = (e) => {
    dispatch(setFilters({ search: e.target.value.trimStart() }));
  };

  // Runs when the user pastes into the search box
  const handleSearchPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').trim();

    // If it looks like a phone number, clean it (remove spaces, dashes, brackets, +91)
    const isPhoneLike = /^[+\d\s\-()]+$/.test(pasted);
    const cleaned = isPhoneLike
      ? pasted.replace(/[\s\-()]/g, '').replace(/^\+?91(?=\d{10}$)/, '')
      : pasted;

    dispatch(setFilters({ search: cleaned }));
  };

  // Handle filter changes from BigFilter
  const handleFilterChange = (selectedValues) => {
    const genders = selectedValues.filter(val =>
      filterGenderWise.some(opt => opt.value === val));
    dispatch(setFilters({ gender: genders }));
  };

  // Combine all selected filters for BigFilter value prop
  const selectedFilters = [...filters.gender];
/* PASSWORD SUBMIT  */
  const handleAuthSubmit = async () => {
  if (!password) {
    setShowMessage({ message: 'Enter login password', messageType: 'error' });
    return;
  }

  if (!ownerId) {
    setShowMessage({ message: 'Owner ID not found. Please refresh and try again.', messageType: 'error' });
    return;
  }

  try {
    setAuthLoading(true);
    const res = await OwnerVarification(ownerId, { password });

    if (res?.statusCode === 200) {
      localStorage.setItem('reportAccessTimestamp', Date.now());
      setIsAuthorised(true);
      setAuthOpen(false);
      setPassword('');
      setShowPassword(false);
    } else {
      setShowMessage({ message: res?.message || 'Invalid password', messageType: 'error' });
    }
  } catch (err) {
    console.error('Auth error:', err);
    setShowMessage({ message: 'Something went wrong', messageType: 'error' });
  } finally {
    setAuthLoading(false);
  }
};

  /*  MASK VALUE HELPER  */
  const maskValue = (value) => {
    if (!isMasked || isAuthorised) return value;
    if (value === null || value === undefined) return value;
    return '****';
  };

  const handleCloseDialogue = () => {
    setAuthOpen(false);
    setPassword('');
    setShowPassword(false);
  };

  /* BLOCK UI IF NOT AUTHORISED  */
  if (isMasked && !isAuthorised) {
    return (
      <PageContainer title="Manage Active Staffs" description="This is staff AllStaffs">
        <DashboardCard2 title="Manage Active Staffs">
          <Dialog open={authOpen} onClose={handleCloseDialogue}>
            <DialogTitle>Confirm Request</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please enter the owner password to access this page.
              </DialogContentText>
              <Box style={{ marginTop: '10px' }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextInputs
                      title="Login Password"
                      name="password"
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      handleChange={(e) => setPassword(e.target.value)}
                      disabled={authLoading}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                              edge="end"
                              disabled={authLoading}
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialogue}>Cancel</Button>
              <Button onClick={handleAuthSubmit} disabled={authLoading}>
                {authLoading ? 'Verifying...' : 'Submit'}
              </Button>
            </DialogActions>
          </Dialog>
        </DashboardCard2>
      </PageContainer>
    );
  }


  return (
    <PageContainer title="Manage Active Staffs" description="This contains all data">
      <DashboardCard2 title="Manage Active Staffs">
        {/* Main container with proper alignment */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginBottom: '1.7rem',
          }}
        >
          {/* Left side - Page limit */}
          <div>
            <InputLabel>Show per page</InputLabel>
            <Select
              style={{
                borderRadius: '7px',
                border: '0.5px solid #6174DD',
                padding: '4px 12px',
                background: '#FFF',
                height: '40px',
                minWidth: '83px',
              }}
              value={pagination.itemsPerPage}
              onChange={handleLimitChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
                                  <MenuItem value={1000000}>All</MenuItem>

            </Select>
          </div>

          {/* Right side - Search, Filter and Work Analysis button */}
          <div style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem'
          }}>
            {/* Search input */}
                <div style={{ display: 'flex', flexDirection: 'column', width: '170px' }}>
              <InputLabel>Search</InputLabel>
              <div 
                className="search-input" 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  border: '0.5px solid #6174DD',
                  borderRadius: '7px',
                  padding: '4px 12px',
                  background: '#FFF',
                  height: '40px',
                  minWidth: '170px'
                }}
              >
                <img src={SearchImg} alt="" style={{ marginRight: '8px' }} />
                <input
                  style={{ 
                    flex: 1, 
                    border: 'none', 
                    outline: 'none',
                    background: 'transparent'
                  }}
                  type="text"
                  placeholder="Search Staff..."
                  value={filters.search}
                  onChange={handleSearchChange}
                  onPaste={handleSearchPaste}
                />
                {filters.search && (
                  <IconButton
                    onClick={() => dispatch(setFilters({ search: '' }))}
                    style={{ padding: 1 }}
                  >
                    <ClearIcon
                      style={{
                        color: '#000',
                        fontSize: '1.1rem',
                      }}
                    />
                  </IconButton>
                )}
              </div>
            </div>

            {/* Filter */}
            <div>
              <BigFilter
                options={[
                  { title: 'Gender', items: filterGenderWise },
                ]}
                value={selectedFilters}
                onChange={handleFilterChange}
                placeholder="Filters"
              />
            </div>

            {/* Work Analysis button */}
            {/* <div>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  height: '40px',
                  background: '#6174dd',
                  '&:hover': { background: '#5d87ff' },
                  minWidth: '140px'
                }}
                onClick={() => navigate('/WorkAnalysis')}
              >
                Work Analysis
              </Button>
            </div> */}
          </div>
        </div>

        {loading ? (
          <ShowLoader />
        ) : displayedStaffs.length > 0 ? (
          <>
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={12}>
                  <FieldData data={displayedStaffs} getData={getData} />
                </Grid>
              </Grid>
            </Box>
          </>
        ) : (
          'No data found'
        )}

        {pagination.totalItems > 0 && (
          <Box display={'flex'} justifyContent={'flex-end'} mt={3}>
            <Pagination
              count={pagination.totalPages}
              page={pagination.currentPage}
              color="primary"
              onChange={handlePageChange}
            />
          </Box>
        )}
      </DashboardCard2>
    </PageContainer>
  );
};

export default AllStaffs;